module.exports = __webpack_public_path__ + "videos/3d-model_cn.d88a26b.mp4";